import api from './client';
import type { ApiResponse, CouponResponse, CouponListResponse } from '../../types/api';

export const generateCoupon = async (data: {
  credits: number;
  recipientEmail: string;
  recipientName: string;
  type: 'existing' | 'prospective';
}): Promise<CouponResponse> => {
  return api.post<any, CouponResponse>('/api/coupons/generate', data);
};

export const listCoupons = async (): Promise<CouponListResponse> => {
  return api.get<any, CouponListResponse>('/api/coupons/list');
};

export const redeemCoupon = async (code: string): Promise<CouponResponse> => {
  return api.post<any, CouponResponse>('/api/coupons/redeem', { code });
};

export const resendCoupon = async (id: string): Promise<ApiResponse> => {
  return api.post<any, ApiResponse>(`/api/coupons/${id}/resend`);
};

export const deleteCoupon = async (id: string): Promise<ApiResponse> => {
  return api.delete<any, ApiResponse>(`/api/coupons/${id}`);
};